(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('PriorityAppraiserDialogController', PriorityAppraiserDialogController);

    PriorityAppraiserDialogController.$inject = ['$state', '$mdDialog', '$q', '$translate', 'region', 'Enum', 'PriorityAppraiser', 'AlertService'];

    function PriorityAppraiserDialogController ($state, $mdDialog, $q, $translate, region, Enum, PriorityAppraiser, AlertService) {
        var vm = this;

        vm.region = region;
        // Tabs are data-driven from the enum: adding a category on the backend adds a tab automatically.
        vm.categories = (Enum && Enum.PriorityAppraiserCategory) ? Enum.PriorityAppraiserCategory : [];
        vm.currentCategory = vm.categories.length ? vm.categories[0] : null;

        vm.isLoading = false;
        vm.isSaving = false;
        // Per-category state: { members, candidates, searchText, selectedCandidate, dirty }
        vm.data = {};
        vm.eligibility = {}; // category -> resolved header text
        // Order types each priority category feeds at dispatch, listed under the hint so it is clear
        // what "priority" applies to. Mirrors AppraisalOrder.priorityAppraiserCategory() on the
        // backend — keep in sync if a category gains or loses an order type. Values are AppraisalType
        // enum keys (rendered via valueconnectApp.EnumAppraisalType.*); a category with no entry here
        // simply shows no list.
        vm.coveredOrderTypes = {
            MARKET_RENT_NO_VISIT: [
                'STANDALONE_MARKET_RENT_NO_VISIT',
                'STANDALONE_MARKET_RENT_NEW_BUILD_NO_VISIT',
                'MARKET_RENT_CONSULTING',
                'AUTOMATED_MARKET_RENT_REPORT'
            ]
        };
        vm.categories.forEach(function(cat) {
            vm.data[cat] = { members: [], candidates: [], searchText: '', selectedCandidate: null, dirty: false };
            loadEligibilityText(cat);
        });

        vm.selectCategory = selectCategory;
        vm.current = current;
        vm.availableCandidates = availableCandidates;
        vm.searchCandidates = searchCandidates;
        vm.add = add;
        vm.remove = remove;
        vm.save = save;
        vm.cancel = cancel;

        loadAllSequentially();

        function current() {
            return vm.currentCategory ? vm.data[vm.currentCategory] : null;
        }

        function selectCategory(cat) {
            vm.currentCategory = cat;
        }

        // Load every category upfront but SEQUENTIALLY (chained), so we don't fan out N parallel
        // requests as categories grow.
        function loadAllSequentially() {
            vm.isLoading = true;
            vm.categories.reduce(function(chain, cat) {
                return chain.then(function() { return loadCategory(cat); });
            }, $q.resolve()).finally(function() {
                vm.isLoading = false;
            });
        }

        function loadCategory(cat) {
            return PriorityAppraiser.query({ regionId: region.id, category: cat }).$promise
                .then(function(members) {
                    vm.data[cat].members = members;
                    return PriorityAppraiser.candidates({ regionId: region.id, category: cat }).$promise;
                })
                .then(function(candidates) {
                    vm.data[cat].candidates = candidates;
                });
        }

        function availableCandidates(cat) {
            var state = vm.data[cat];
            if (!state) { return []; }
            var chosen = state.members.map(function(m) { return m.appraiserUserId; });
            return state.candidates.filter(function(c) { return chosen.indexOf(c.appraiserUserId) === -1; });
        }

        function searchCandidates(query) {
            var available = availableCandidates(vm.currentCategory);
            if (!query) { return available; }
            var lower = query.toLowerCase();
            return available.filter(function(c) {
                return c.fullName && c.fullName.toLowerCase().indexOf(lower) !== -1;
            });
        }

        function add(candidate) {
            var state = current();
            if (!candidate || !state) { return; }
            var exists = state.members.some(function(m) { return m.appraiserUserId === candidate.appraiserUserId; });
            if (!exists) {
                state.members.push(candidate);
                state.dirty = true;
            }
            state.selectedCandidate = null;
            state.searchText = '';
        }

        function remove(member) {
            var state = current();
            if (!state) { return; }
            state.members = state.members.filter(function(m) { return m.appraiserUserId !== member.appraiserUserId; });
            state.dirty = true;
        }

        // Persist only the categories the admin actually changed, sequentially. Stay open on success.
        function save() {
            var dirtyCats = vm.categories.filter(function(cat) { return vm.data[cat].dirty; });
            if (!dirtyCats.length) {
                $mdDialog.cancel();
                $state.go('region', null);
                return;
            }
            vm.isSaving = true;
            dirtyCats.reduce(function(chain, cat) {
                return chain.then(function() {
                    var ids = vm.data[cat].members.map(function(m) { return m.appraiserUserId; });
                    return PriorityAppraiser.update({ regionId: region.id, category: cat }, ids).$promise
                        .then(function(result) {
                            vm.data[cat].members = result;
                            vm.data[cat].dirty = false;
                        });
                });
            }, $q.resolve()).then(function() {
                AlertService.success('valueconnectApp.region.priorityAppraisers.updated', { regionName: region.name });
            }).catch(function(error) {
                var message = (error && error.data && error.data.description) || 'An error occurred while saving priority appraisers.';
                AlertService.error(message);
            }).finally(function() {
                vm.isSaving = false;
            });
        }

        function cancel () {
            $mdDialog.cancel();
            $state.go('region', null);
        }

        // Specific-per-category eligibility text with a generic fallback, so a future category still
        // renders sensible text with no code change.
        function loadEligibilityText(cat) {
            var specificKey = 'valueconnectApp.region.priorityAppraisers.eligibility.' + cat;
            var genericKey = 'valueconnectApp.region.priorityAppraisers.eligibility.generic';
            $translate(specificKey).then(function(text) {
                if (text && text !== specificKey) {
                    vm.eligibility[cat] = text;
                } else {
                    useGeneric(cat, genericKey);
                }
            }, function() {
                useGeneric(cat, genericKey);
            });
        }

        function useGeneric(cat, genericKey) {
            $translate(genericKey).then(function(text) {
                vm.eligibility[cat] = text;
            }, function() {
                vm.eligibility[cat] = '';
            });
        }
    }
})();
